import APIImg from "../../Images/API.jpeg";
import ReactorImg from "../../Images/Reactor2.jpeg";
export function API() {
  return (
    <section className="about-wrap-layout1">
      <div className="container">
        <div className="row">
          <div className="about-box-layout1 order-xl-8 col-xl-8 col-12">
            <div className="item-content">
              <h2 className="item-title"> API MANUFACTURING </h2>
              <p>
                The production of our bulk drugs (APIs) involves the process of
                organic chemical synthesis, which is performed in multi-purpose
                reactors through batch operations. This process is followed by
                the isolation of the product using various techniques, including
                name reactions like hydrogenation, Friedel-Crafts, halogenation,
                Grignard reactions, autoclave processing, high-vacuum
                distillation, extraction, crystallization, and filtration. The
                finished products are then dried, milled, and blended. This is a
                complex, multi-step process where the product from one step
                serves as the starting material for the next step, continuing
                until the finished drug product is synthesized.
              </p>
              <h4>
                {" "}
                Our APIs are currently manufactured in designated facilities as
                below:{" "}
              </h4>
              <h4> High Volume: </h4>
              <p>
                {" "}
                For High volume APIs & intermediates.
                <br />
                Equipped with high-grade equipment, including stainless steel
                and glass reactors, high-vacuum distillation apparatus, solvent
                recovery plants, centrifuges, vacuum tray dryers, rotocone
                vacuum dryers, sparkler filters, sifters, and multi-mills, the
                facility is a classified (Class ISO-8/Class-D) manufacturing
                area. It features dedicated HVAC systems and is staffed by
                trained professionals. Additionally, we have a separate
                dedicated hydrogenation facility to meet specific requirements.
              </p>
              <h4> Small Volume: </h4>
              <p>
                The world is advancing towards high-cost, low-volume drug
                manufacturing. Producing such drugs is challenging due to the
                specialized prerequisites for facilities (Class ISO-8/Class-D).
                We prioritize the highest Environmental Health & Safety (EHS)
                standards.
              </p>
              <h4>Future Expansion..</h4>
              <h4> High Volume, Small Volume: </h4>
              <p>
                Our Second high and small volume API manufacturing facility is
                under development in full swing which would be equipped with
                state-of-the-art equipment to cater to our customer’s growing
                requirements of high volumes of APIs.
              </p>
            </div>
          </div>

          <div
            className="about-box-layout2 order-xl-1 col-xl-4 col-lg-4 col-12"
            style={{ marginBottom: "20px" }}
          >
            <div className="item-im">
              <img src={APIImg} alt="about" className="img-fluid" />
            </div>
            <div className="item-im" style={{ marginTop: "18px" }}>
              <img src={ReactorImg} alt="about" className="img-fluid" />
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}
